import axios from "axios";
import ElementUI from "element-ui";
import router from "../router";
const service = axios.create({
  baseURL: "https://www.yuqing.cn/",
  // baseURL: "https://test.yuqing.cn/",
  // baseURL: "https://test01.yuqing.cn",
});
service.all = axios.all;
service.interceptors.request.use(
  function (config) {
    // 一般在这个位置判断token是否存在
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
//响应拦截的风度回复
service.interceptors.response.use(
  function (response) {
    // 处理响应数据
    if (response.data.code === 200) {
      return Promise.resolve(response);
    } else if (response.data.code === 401) {
      ElementUI.Message({
        message: response.data.msg,
        type: "warning",
      });
      router.push({
        path: "/login",
      });
    } else if (response.data.code === 403 || response.data.code === 407) {
      router.push({
        path: "/login",
      });
    } else if (response.data.code === 400) {
      ElementUI.Message({
        message: response.data.msg,
        type: "warning",
      });
    } else {
      return response;
    }
  },
  function (error) {
    // 处理响应失败
    return Promise.reject(error);
  }
);
export default service;

